/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WithdrawalsRouteImport } from './routes/withdrawals'
import { Route as SimsRouteImport } from './routes/sims'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrdersOrderIdRouteImport } from './routes/orders.$orderId'

const WithdrawalsRoute = WithdrawalsRouteImport.update({
  id: '/withdrawals',
  path: '/withdrawals',
  getParentRoute: () => rootRouteImport,
} as any)
const SimsRoute = SimsRouteImport.update({
  id: '/sims',
  path: '/sims',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => OrdersRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/login': typeof LoginRoute
  '/orders': typeof OrdersRouteWithChildren
  '/settings': typeof SettingsRoute
  '/sims': typeof SimsRoute
  '/withdrawals': typeof WithdrawalsRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/login': typeof LoginRoute
  '/orders': typeof OrdersRouteWithChildren
  '/settings': typeof SettingsRoute
  '/sims': typeof SimsRoute
  '/withdrawals': typeof WithdrawalsRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/login': typeof LoginRoute
  '/orders': typeof OrdersRouteWithChildren
  '/settings': typeof SettingsRoute
  '/sims': typeof SimsRoute
  '/withdrawals': typeof WithdrawalsRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/login'
    | '/orders'
    | '/settings'
    | '/sims'
    | '/withdrawals'
    | '/orders/$orderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/login'
    | '/orders'
    | '/settings'
    | '/sims'
    | '/withdrawals'
    | '/orders/$orderId'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/login'
    | '/orders'
    | '/settings'
    | '/sims'
    | '/withdrawals'
    | '/orders/$orderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRoute: typeof AnalyticsRoute
  LoginRoute: typeof LoginRoute
  OrdersRoute: typeof OrdersRouteWithChildren
  SettingsRoute: typeof SettingsRoute
  SimsRoute: typeof SimsRoute
  WithdrawalsRoute: typeof WithdrawalsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/withdrawals': {
      id: '/withdrawals'
      path: '/withdrawals'
      fullPath: '/withdrawals'
      preLoaderRoute: typeof WithdrawalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sims': {
      id: '/sims'
      path: '/sims'
      fullPath: '/sims'
      preLoaderRoute: typeof SimsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderId': {
      id: '/orders/$orderId'
      path: '/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdRouteImport
      parentRoute: typeof OrdersRoute
    }
  }
}

interface OrdersRouteChildren {
  OrdersOrderIdRoute: typeof OrdersOrderIdRoute
}

const OrdersRouteChildren: OrdersRouteChildren = {
  OrdersOrderIdRoute: OrdersOrderIdRoute,
}

const OrdersRouteWithChildren =
  OrdersRoute._addFileChildren(OrdersRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRoute: AnalyticsRoute,
  LoginRoute: LoginRoute,
  OrdersRoute: OrdersRouteWithChildren,
  SettingsRoute: SettingsRoute,
  SimsRoute: SimsRoute,
  WithdrawalsRoute: WithdrawalsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
